<template>
<span>
  {{ label }}
  <v-layout>
          <v-autocomplete
              :search-input.sync="searchInput"
              v-model="storageProductId"
              :items="storageItems"
              label="Produkt"
              item-text="name"
              :loading="isLoading"
              item-value="id"
              persistent-hint
              placeholder="Start typing to Search"
              prepend-icon="mdi-city"
          >
                <template v-slot:selection="data" >
                  {{ data.item ? `${data.item.name} (${data.item.quantity})`: ''}}
                </template>
                <template v-slot:item="data" >
                  {{ data.item ? `${data.item.name} (${data.item.quantity})` : ''}}
                </template>
          </v-autocomplete>

    <v-text-field ref="numberField" v-model="model" label="Ilość" type="number"></v-text-field>
    {{ description }}
  </v-layout>

</span>
</template>

<script>
import {
  input
} from '@/mixins/input'
import InputNumberValidator from '@/plugins/validator/number/InputNumberValidator'
import InputHelper from '@/plugins/InputHelper'
import {
  observerField
} from '@/mixins/observerField'

export default {
  data() {
    return {
      searchInput:"",
      item: null,
      isLoading: false,
      storageItems:[],
      storageProductId: null,
      validator: undefined
    }
  },
  mixins: [input, observerField],
  mounted() {
    if (this.field.options && this.field.options.expanded) {
      this.validator = new InputNumberValidator(this, this.$refs.numberField.$refs.input, this.field, this.context)
      this.registerValidatorWatcher()
    }
  },
  methods: {
    registerValidatorWatcher() {
      this.$watch('changedContextData', function(newValue, oldValue) {
        this.validator.matchAndValidate()
      }, {
        deep: true
      });
    },
    beforeSend(val) {
      val = String(val).replace(",", ".")
      return {'productId': this.storageProductId, amount: val}

      return +val
    },
    getUrl(searchText){
      if (this.field.options && this.field.options.storage_type_id > 0){
        return 'storage/type/' + this.field.options.storage_type_id + '/items?&filter[name][like]=' + searchText
      }
      return 'storage?&filter[name][like]=' + searchText
    }
  },
  watch:{
    searchInput:function (newSearch){
      if(!this.isLoading && newSearch && newSearch.length > 2){
        this.isLoading = true
        this.$http.get(this.getUrl(newSearch)).then(data=>{
          this.isLoading = false
          this.storageItems = data.data
        })
      }
    }
  }
}
</script>

<style>
</style>
